export default __webpack_public_path__ + "static/media/arko.6d7fa573.ico";